import { BsTwitterX } from 'react-icons/bs'
import {
	FaFacebook,
	FaLinkedin,
	FaMapMarkerAlt,
	FaPhoneAlt,
	FaTelegram,
	FaYoutube,
} from 'react-icons/fa'
import { IoMdMail } from 'react-icons/io'
import { IoLogoInstagram } from 'react-icons/io5'
import './Footer.scss'

const Footer = () => {
	return (
		<footer className='footer'>
			<div className='content'>
				<div className='company'>
					<div className='company-logo'>
						<img className='logo' src='/dan-3-trading-logo.png' alt='logo' />
						<span>DAN 3 Trading GmbH</span>
					</div>
					<q className='сitation'>
						Grow with us - the land is our common cause!
					</q>
				</div>

				<div className='media'>
					<div className='social-network'>
						<IoLogoInstagram />
					</div>
					<div className='social-network'>
						<FaFacebook />
					</div>
					<div className='social-network'>
						<BsTwitterX />
					</div>
					<div className='social-network'>
						<FaLinkedin />
					</div>
					<div className='social-network'>
						<FaYoutube />
					</div>
					<div className='social-network'>
						<FaTelegram />
					</div>
				</div>

				<div className='contacts'>
					<div className='phone'>
						<FaPhoneAlt size={25} />
						<span>+43 664 1531 501 Tanja Kaiser</span>
					</div>
					<div className='phone'>
						<FaPhoneAlt size={25} />
						<span>+43 664 1323 558 Jan Kaiser</span>
					</div>
					<div className='phone'>
						<IoMdMail size={20} />
						<span>dan3trading@dan3trading.com</span>
					</div>
					<div className='phone'>
						<FaMapMarkerAlt size={20} />
						<span style={{ whiteSpace: 'pre-wrap' }}>
							{`St. Veiter Straße 101, \n9020 KLAGENFURT, Österreich`}
						</span>
					</div>
					<div className='phone'>FN 684862 a | UID: AT U83574428</div>
					<div className='phone flex-col !items-start text-xs pt-1 opacity-90'>
						<span className='font-semibold'>Kärntner Sparkasse Aktiengesellschaft</span>
						<span>IBAN: AT49 2070 6047 0017 0980</span>
						<span>BIC / SWIFT: KSPKAT2KXXX</span>
					</div>
				</div>
			</div>

			<div className='copywriting'>
				<span>(C) Copyright 2025, DAN 3 Trading GmbH</span>
			</div>
		</footer>
	)
}

export default Footer
